import {
  deleteDataTraining,
  fetchDataTraining,
  patchDataTraining,
  postDataTraining,
} from "../services/training";

const handleFetchCourses = async () => {
  const uri = `api/courses`;
  const response = fetchDataTraining({ uri });
  return response;
};

const handleFetchCourse = async ({ _id }: any) => {
  const uri = `api/courses/${_id}`;
  const response = fetchDataTraining({ uri });
  return response;
};

const handleCreateCourse = async (data: any) => {
  const uri = `api/courses`;
  const response = postDataTraining({ data, uri });
  return response;
};

const handleUpdateCourse = async ({ data, course_id }: any) => {
  const uri = `api/courses/${course_id}`;
  const response = patchDataTraining({ data, uri });
  return response;
};

const handleDeleteCourse = async ({ _id }: any) => {
  const uri = `api/courses/${_id}`;
  const response = deleteDataTraining({ uri });
  return response;
};

const handleAssignInstructor = async ({ data, _id }: any) => {
  const uri = `api/courses/${_id}/instructor`;
  const response = postDataTraining({ data, uri });
  return response;
};

const handleUploadThumbnail = async ({ data, course_id }: any) => {
  const uri = `api/courses/${course_id}/thumbnail`;
  const response = patchDataTraining({ data, uri });
  return response;
};

const handleCreateOutline = async ({ data, course_id }: any) => {
  const uri = `api/courses/${course_id}/outline`;
  const response = patchDataTraining({ data, uri });
  return response;
};

const handleDeleteOutline = async ({ data, course_id }: any) => {
  const uri = `api/courses/${course_id}/outline`;
  const response = deleteDataTraining({ data, uri });
  return response;
};

const handleAddToWishlist = async ({ data, course_id }: any) => {
  const uri = `api/courses/${course_id}/wishlist`;
  const response = patchDataTraining({ data, uri });
  return response;
};

const handleRemoveFromWishlist = async ({ data, course_id, user_id }: any) => {
  const uri = `api/courses/${course_id}/wishlist/${user_id}`;
  const response = deleteDataTraining({ data, uri });
  return response;
};

export {
  handleFetchCourses,
  handleFetchCourse,
  handleCreateCourse,
  handleUpdateCourse,
  handleDeleteCourse,
  handleCreateOutline,
  handleDeleteOutline,
  handleUploadThumbnail,
  handleAddToWishlist,
  handleRemoveFromWishlist,
  handleAssignInstructor,
};
